module.exports = __webpack_public_path__ + "static/media/licencia_frente@2x.ae899085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/licencia_frente@2x.jpg
// module id = 650
// module chunks = 0